<template>
  <div :class="classes" @click="handleClick">
    <Image
      :image-force-aspect-ratio="aspectRatio || '4_3'"
      :image-rounded-corners="image?.imageRoundedCorners || false"
      :single-src="image?.defaultSrc || ''"
      :imageSrcset="image?.imageSrcset || []"
    />
    <div class="card-slider-item__inner">
      <div class="card-slider-item__inner__text">
        <Paragraph v-if="label" :content="labelContent" size="small" />
        <Heading
          v-if="title"
          :content="titleContent"
          role="headline"
          size="small"
          tag="h3"
        />
      </div>
      <div class="card-slider-item__inner__cta">
        <LinkButton v-if="button" button-type="filled" :url="buttonUrl">
          {{ buttonContent }}
        </LinkButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import './CardSliderItem.scss';
import { computed } from 'vue';
import Image from 'ewi-ui/components/1-atoms/Media/Image/Image.vue';
import Paragraph from '../../1-atoms/Paragraph/Paragraph.vue';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import LinkButton from 'ewi-ui/components/1-atoms/LinkButton/LinkButton.vue';
import { ImageProps } from 'ewi-ui/components/1-atoms/Media/Image/Image.vue';
import { AspectRatio } from 'ewi-ui-helpers/types';

export interface CardSliderItemInterface {
  label?: boolean;
  labelContent?: string;
  title?: boolean;
  titleContent?: string;
  button?: boolean;
  buttonContent?: string;
  buttonUrl?: string;
  image?: ImageProps;
  aspectRatio?: '' | AspectRatio;
}

withDefaults(defineProps<CardSliderItemInterface>(), {
  label: true,
  labelContent: '',
  title: true,
  titleContent: '',
  button: true,
  buttonContent: '',
  buttonUrl: '',
  aspectRatio: '',
  roundedCorners: false,
});

const classes = computed(() => ({
  'card-slider-item': true,
}));

const handleClick = (event: Event) => {
  event.stopPropagation();

  const linkElement = (event.currentTarget as HTMLElement).querySelector(
    '.card-slider-item__inner__cta a',
  ) as HTMLAnchorElement;

  if (linkElement) {
    linkElement.click();
  }
};
</script>
